"use client";

import { useEffect, useState } from "react";

export default function useIsClient<T>(getter: () => T, initialValue: T = null): T | null {
  const [value, setValue] = useState<T>(initialValue);
  useEffect(() => {
    setValue(getter());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return value;
}
